module.exports = __webpack_public_path__ + "static/media/logo_white.c8fa4f37.png";